<mat-card class="cur-card" formGroupName="supplyresumptionResultInfo">
    <mat-card-content class="tw-flex tw-flex-row">
        <mat-card class="mat-elevation-z0 grp-card w-full">
            <mat-card-header>
                <mat-card-subtitle class="mat-label-outline">目視点検等</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>

                <!-- １段目 -->
                <div class="tw-flex tw-flex-row justify-evenly" style="margin-top: 1%; margin-bottom: 1%;">
                    <mat-radio-group color="warn" (change)="onChangeCheck()" formControlName="meterExteriorAbnormalflag"
                        class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label class="mat-label-ragiogroup">メーター外観</mat-label>
                        <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                            *ngFor="let code of codeMap?.get('S301290')">{{code.hyojiCont}}</mat-radio-button>
                    </mat-radio-group>

                    <mat-radio-group color="warn"
                        class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]"
                        (change)="onChangeCheck()" formControlName="meterGassenAbnormalflag">
                        <mat-label class="mat-label-ragiogroup">メーターガス栓</mat-label>
                        <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                            *ngFor="let code of codeMap?.get('S301300')">{{code.hyojiCont}}</mat-radio-button>
                    </mat-radio-group>

                    <mat-radio-group color="warn"
                        class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]"
                        (change)="onChangeCheck()" formControlName="microcontrollermeterTestblockAbnormalflag">
                        <mat-label class="mat-label-ragiogroup">マイコンメーターテスト遮断</mat-label>
                        <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                            *ngFor="let code of codeMap?.get('S301310')">{{code.hyojiCont}}</mat-radio-button>
                    </mat-radio-group>
                </div>

                <!-- ２段目 -->
                <div class="tw-flex tw-flex-row justify-evenly" style="margin-top: 1%; margin-bottom: 1%;">
                    <mat-radio-group color="warn"
                        class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]"
                        (change)="onChangeCheck()" formControlName="microcontrollermeterReturnAbnormalflag">
                        <mat-label class="mat-label-ragiogroup">マイコンメーター復帰</mat-label>
                        <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                            *ngFor="let code of codeMap?.get('S301320')">{{code.hyojiCont}}</mat-radio-button>
                    </mat-radio-group>

                    <div *ngIf="sagyoshubetsuCD == '2'; then generalResumptionSupply; else simplifiedResumptionSupply">
                    </div>
                    <!-- 一般供給再開 -->
                    <ng-template #generalResumptionSupply>
                        <mat-radio-group color="warn"
                            class="customer-radio-group tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[500px] tw-max-w-[500px] tw-min-w-[500px]"
                            style="height: 50px; margin-left: 2%; position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
                            <div class="tw-flex tw-flex-row" id="leaktest">
                                <p style="margin-top: 2.5%;margin-left: 2%; margin-right: 2%;height: 1em;width: 15em;">
                                    灯内内管の漏えい確認</p>
                                <mat-form-field style="margin-top: 1%;" appearance="outline"
                                    class="remove-top tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[100px] tw-max-w-[100px] tw-min-w-[100px]">
                                    <input class="test" type="number" min="0" max="999" matInput
                                        formControlName="leaktestAtrk" (change)="onChangeCheck()" />
                                </mat-form-field>

                                <p style="margin-top: 3%;margin-left: 2%; margin-right: 2%;">kPa</p>
                                <mat-form-field style="margin-top: 1%;" appearance="outline"
                                    class="remove-top tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[100px] tw-max-w-[100px] tw-min-w-[100px]">
                                    <input class="test" type="number" min="0" max="60" matInput
                                        formControlName="leaktestTime" (change)="onChangeCheck()" />
                                </mat-form-field>
                                <p style="margin-top: 3%;margin-left: 2%; margin-right: 2%;">分</p>

                            </div>
                        </mat-radio-group>
                    </ng-template>

                    <!-- 簡易供給再開 -->
                    <ng-template #simplifiedResumptionSupply>
                        <mat-radio-group color="warn" class="search-condition-radio-frame"
                            class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]"
                            (change)="onChangeCheck()" formControlName="operationcheckLeaktestKahiflg">
                            <mat-label class="mat-label-ragiogroup"> 動止確認による漏えい検査</mat-label>
                            <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                                *ngFor="let code of codeMap?.get('S301330')">{{code.hyojiCont}}</mat-radio-button>
                        </mat-radio-group>
                        <mat-form-field appearance="outline"
                            class="remove-top-margin search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]"
                            style="margin-left: 25px; margin-bottom: 12px; height: 40px;">
                            <mat-label>メーター指針動止確認</mat-label>
                            <mat-select class="disabled-select-color" (selectionChange)="onChangeCheck()"
                                formControlName="meterShishinstartandstopConfirmationcode">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let type of codeMap?.get('S300860')" class="font-color-display-only"
                                    [value]="type.userCode">{{type.hyojiCont}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-template>
                </div>

                <!-- ３段目 -->
                <div class="tw-flex tw-flex-row justify-evenly" style="margin-top: 1%; margin-bottom: 1%;">
                    <mat-radio-group color="warn" class="search-condition-radio-frame"
                        class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]"
                        (change)="onChangeCheck()" formControlName="leaktestConfirmationresultFlg">
                        <mat-label class="mat-label-ragiogroup">確認結果</mat-label>
                        <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                            *ngFor="let code of codeMap?.get('S301340')">{{code.hyojiCont}}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </mat-card-content>
        </mat-card>

        <div style="margin-top: 2%;">
            <mat-radio-group color="warn" class="customer-radio-group"
                class="search-condition-radio-frame tw-flex tw-flex-row tw-flex-wrap"
                style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px; height: 150px;">
                <mat-label class="mat-label-ragiogroup" id="chudanjiShori">中断時の処置</mat-label>

                <div class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]"
                    style="width: 400px; margin-top: 2%; margin-left: 2%;">
                    <mat-checkbox class="check-box" color="primary" [checked]="meterGassenShutoffflag"
                        id="meterGassenShutoffflag" (change)="meterGassenShutoffflag = $event.checked"
                        style="margin-right: 2%;" [disabled]="getControl('meterGassenShutoffflag')?.disabled">
                        メーターガス栓閉止
                    </mat-checkbox>
                    <mat-checkbox class="check-box" color="primary" [checked]="meterPauseSochiflag"
                        id="meterPauseSochiflag" (change)="meterPauseSochiflag = $event.checked"
                        style="margin-right: 2%;" [disabled]="this.getControl('meterPauseSochiflag')?.disabled">
                        メーター休止措置
                    </mat-checkbox>
                </div>

                <div class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]"
                    style="margin-top: 25px; margin-left: 2%;">
                    <mat-form-field appearance="outline"
                        class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>業務引継</mat-label>
                        <mat-select formControlName="inspectiontaskTakeovertoCode">
                            <mat-option value="" selected></mat-option>
                            <mat-option *ngFor="let div of codeMap?.get('S300870')"
                                [value]="div.userCode">{{div.hyojiCont}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </mat-radio-group>
        </div>
        <div style="margin-top: 100px;"></div>
    </mat-card-content>
</mat-card>